export default "__VITE_ASSET__CIQ7Lnc7__"